<template>
  <v-card>
    <v-card-title test-tag="tag-125">
      <T>Дополнительно</T>
      <v-spacer></v-spacer>
      <v-btn test-tag="tag-124" @click="$emit('done')" fab color="primary" :disabled="invalid_groups.length > 0" small><v-icon>mdi-check</v-icon></v-btn>
    </v-card-title>
    <v-card-subtitle>{{item_name}}</v-card-subtitle>
    <ModifiersGroup v-for="g in scheme_groups" :key="g.id" :group="g" v-model="modifiers" @inc="inc" @dec="dec" :invalid="invalid_groups.includes(g.id)"/>
    <v-dialog :value="combo_item !== undefined" @click:outside="combo_item = undefined" max-width="400px" persistent scrollable>
      <ModifiersEditor @done="modifiers = [...modifiers, combo_item]; combo_item=undefined" v-if="combo_item !== undefined" :scheme="combo_item.modifier.modischeme_ref" :item_name="combo_item.modifier.name" v-model="combo_item.modifiers" />
    </v-dialog>
    
  </v-card>  
</template>

<script>
import { mapGetters } from 'vuex'
import ModifiersGroup from './ModifiersGroup.vue'

export default {
  name: "ModifiersEditor",
  props: ['scheme', 'value', 'item_name'],
  data: () => ({
    combo_item: undefined
  }),
  methods: {
    portionsOfGroup(group, modifiers){
      return modifiers.filter(el => el.modifier.group.id === group.id)
    },
    portionsCount(portions){
      return portions.reduce((prev, cur) => prev+cur.quantity, 0)
    },
    inc(modifier){

      let portions = this.portionsOfGroup(modifier.group, this.modifiers)

      if (portions.length > 0) {
        let total_cnt = this.portionsCount(portions)
        console.log(total_cnt)
        if (total_cnt + 1 > (modifier.group.uplimit || undefined)) {
          let rm_portion = portions.filter(el => el.modifier.id != modifier.id)[0]
          if (rm_portion !== undefined) {
            this.dec(rm_portion.modifier)
          } else return
        }
      }

      this.$nextTick(() => { //wait for external 'value' updated in case of decreased value on previous step
        let portion = this.modifiers.filter(el => el.modifier.id ===  modifier.id)[0]

        if (portion === undefined) {
          if (modifier.modischeme_ref != null) {
            this.combo_item = {
              modifier,
              quantity: 1,
              modifiers: []
            }
            return
          }
          this.modifiers = [...this.modifiers, {modifier, quantity: 1, modifiers: []}]
        } else {
          portion.quantity += 1
          this.modifiers = [...this.modifiers]
        }

      })
    },
    dec(modifier){
      let portion = this.modifiers.filter(el => el.modifier.id ===  modifier.id)[0]

      
      if (portion !== undefined) {
        portion.quantity -= 1
        if (portion.quantity <= 0) {
          this.modifiers = this.modifiers.filter(el => el.modifier.id !== modifier.id)
        } else {
          this.modifiers = [...this.modifiers]
        }
      }
    }
  },
  computed: {
    invalid_groups(){
      return this.scheme_groups.filter(el => this.portionsCount(this.portionsOfGroup(el, this.modifiers)) < el.downlimit).map(el => el.id)
    },
    ...mapGetters(['menu_modifier_schemes_map']),
    scheme_groups(){
      return this.menu_modifier_schemes_map[this.scheme] || []
    },
    modifiers: {
      get(){
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  },
  components: {
    ModifiersGroup,
  }
}
</script>